// Admin "System" settings API: read-only server config + app SQLite backup
// actions (run / list / download). All admin-only on the server.
import { api } from './api.js';

export const getServerInfo = () => api.get('/api/admin/server-info');
export const listBackups   = () => api.get('/api/admin/backups');
export const runBackupNow  = () => api.post('/api/admin/backups/run');

// A plain authenticated GET (cookie-based) — used as an <a download> href.
export const backupDownloadUrl = (name) =>
  `/api/admin/backups/${encodeURIComponent(name)}/download`;
